var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconElectricity7B87E6D717(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.43 9.09a8.53 8.53 0 0 0-6.72-6.84A8.67 8.67 0 0 0 9.55 4a8.57 8.57 0 0 0-1 12.23A6 6 0 0 1 10 20.16v2.31a.75.75 0 0 0 .75.75h8.59a.75.75 0 0 0 .75-.75v-2.29a6 6 0 0 1 1.45-3.95 8.6 8.6 0 0 0 1.89-7.14zm-4.88 11.1v1.53h-2.8v-5.56h-1.5v5.56h-2.77v-1.57a7.49 7.49 0 0 0-1.82-4.87 7.05 7.05 0 0 1 .85-10.08 7.09 7.09 0 0 1 5.92-1.47A7 7 0 0 1 22 9.35a7.08 7.08 0 0 1-1.59 5.9 7.53 7.53 0 0 0-1.86 4.94zm-8.56 6.28h9.98v1.5H9.99z",
    fill: "#231f20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.07,
    r: 2.1,
    fill: "#ffc700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectricity7B87E6D717);
export default __webpack_public_path__ + "static/media/icon_electricity_7b87e6d717.ea089791d6757895c426f82a66068e1d.svg";
export { ForwardRef as ReactComponent };